import { Role } from "./role";
import { JobRole } from './jobRole';
import { Resource } from './resource';

export class User extends Resource {
    value :String;
    label: string;
    name: String;
    String: number;
    //username: string;
    password: string;
    firstName: string;
    lastName: string;
    role: JobRole;
    token?: string;
    fullName:string;
   
    constructor (id?: string){
        super();
        this.id = id;
    }
}